import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class InformationStore {

}

export enum InformationStoreKeys {

}
